import { makeInstaller } from './make-installer'
import Components from './component'

export default makeInstaller([...Components])
